export default __webpack_public_path__ + "static/media/mushroomcupcakes@2x.7e3b7752.jpg";